export default __webpack_public_path__ + "static/media/top-ten-block-3.61c27e39.svg";